export default __webpack_public_path__ + "7429a63c09f79a1760b0233e3e46f776.ttf";